import * as React from "react";
const SvgBBIconsHistoricRelation = (props) => (
  <svg
    width="21"
    height="2"
    viewBox="0 0 21 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line y1="1" x2="2.625" y2="1" stroke="#71B7E6" stroke-width="2" />
    <line x1="18.375" y1="1" x2="21" y2="1" stroke="#71B7E6" stroke-width="2" />
    <line
      x1="4.20001"
      y1="1"
      x2="9.45001"
      y2="1"
      stroke="#71B7E6"
      stroke-width="2"
    />
    <line
      x1="11.025"
      y1="1"
      x2="16.275"
      y2="1"
      stroke="#71B7E6"
      stroke-width="2"
    />
  </svg>
);
export default SvgBBIconsHistoricRelation;
